document.addEventListener('DOMContentLoaded', () => {
    // Select all elements with class .product-form__input--swatch
    const swatches = document.querySelectorAll('.product-form__input--swatch');

    swatches.forEach(swatch => {
        // Find all label elements inside the swatch
        const labels = swatch.querySelectorAll('label');
        
        // Get the image element inside .card__media
        const cardMedia = swatch.closest('.card__content').parentElement.querySelector('.card__media img');
        if (!cardMedia) return; // Exit if no image found

        // Store the original src and srcset of the image
        const originalSrc = cardMedia.getAttribute('src');
        const originalSrcset = cardMedia.getAttribute('srcset');

        labels.forEach(label => {
            // Add mouseenter (hover) event
            label.addEventListener('mouseenter', () => {
                // Get the data-variant-image attribute
                const variantImage = label.getAttribute('data-variant-image');
                if (variantImage) {
                    // Update the image src and srcset
                    cardMedia.setAttribute('src', variantImage);
                    // For simplicity, reuse the variant image for srcset (adjust as needed)
                    cardMedia.setAttribute('srcset', variantImage);
                    console.log('Hover: Updated image to', variantImage);
                }
            });

            // Add mouseleave (out) event
            // label.addEventListener('mouseleave', () => {
            //     // Restore the original src and srcset
            //     cardMedia.setAttribute('src', originalSrc);
            //     cardMedia.setAttribute('srcset', originalSrcset);
            //     console.log('Mouse out: Restored original image');
            // });
        });
    });
});
